var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65637 0.56388L7.60254 1.51005L2.11287 6.99971L7.60254 12.4894L6.65637 13.4355L0.22054 6.99971L6.65637 0.56388Z",
    fill: "#5F6376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackward);
export default __webpack_public_path__ + "static/media/arrow_backward.29467d2b9eabe9aa777fbe037f4323f1.svg";
export { ForwardRef as ReactComponent };